<template>
  <div>
    <fg-input :label="label">
      <el-date-picker
        type="date"
        value-format="yyyy-MM-dd"
        format="dd.MM.yyyy"
        :value="value"
        @input="$emit('input', $event)"
      >
      </el-date-picker>
    </fg-input>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import { FgInput } from "src/components/UIComponents";

export default {
  props: ["value", "label"],
  components: {
    [DatePicker.name]: DatePicker,
    [FgInput.name]: FgInput
  }
};
</script>
